import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";

type Props = {
  value: boolean;
  dense?: boolean;
  title?: string;
  color?: string;
  extended?: boolean;
};
type Emits = {
  (e: "input", val: boolean): void;
  (e: "close"): void;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'FullscreenDialog',
  props: {
    value: { type: Boolean },
    dense: { type: Boolean, default: false },
    title: { default: "" },
    color: { default: "primary" },
    extended: { type: Boolean }
  },
  emits: ["input", "close"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "input", val: boolean): void;
  (e: "close"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: boolean, dense: boolean, title: string, color: string, extended?: boolean };




const modelValue = computed({
  get: () => props.value,
  set: val => emits("input", val)
});

const onClose = () => {
  emits("close");
};

return { __sfc: true,props, emits, modelValue, onClose }
}

})